import {isNullOrUndefined} from "../../../services/Validator";
import LevelAExampleQuestion from "./LevelAExampleQuestion";
import LevelAExampleAnswer from "./LevelAExampleAnswer";
import LevelAExampleExplanation from "./LevelAExampleExplanation";
import {get_nested} from "../../../services/JsonHandler";
import LevelABlockDivider from "../../dividers/LevelABlockDivider";
import LevelACardHeaderText from "../../texts/levelAScreen/LevelACardHeaderText";
import LevelAQuestionButton from "../../buttons/levelAScreen/LevelAQuestionButton";
import {useState} from "react";
import LevelAExampleExplanationDialog from "../../dialogs/levelAScreen/LevelAExampleExplanationDialog";

export default function LevelAExample({levelAKnowledge, isBrevetDisplay}) {
    // Used in LevelAContent to display LevelA Knowledge example

    // PROPERTIES
    // ---- Modal
    const [isModalOpen, setIsModalOpen] = useState(false)
    // ---- Example
    const exampleQuestion = get_nested(['exampleQuestion'], levelAKnowledge, null)
    const exampleAnswer = get_nested(['exampleAnswer'], levelAKnowledge, null)
    const exampleExplanation = get_nested(['exampleExplanation'], levelAKnowledge, null)
    const examplePicture = get_nested(['knowledgeExamplePicture'], levelAKnowledge, null)

    // BUILD
    if (isNullOrUndefined(exampleQuestion) || isNullOrUndefined(exampleAnswer) || isNullOrUndefined(exampleExplanation))
        return null
    return (
        <div className={"w-full flex flex-col justify-start items-center"}>
            <LevelABlockDivider />
            <div className={"bg-primaryDark4/20 border-[1px] border-greyLight3 w-full flex flex-col justify-start items-start px-[16px] py-[16px] rounded-[12px]"}>
                {/** MODAL */}
                <LevelAExampleExplanationDialog open={isModalOpen}
                                                handleClose={processModalClosing} />
                {/** HEADER */}
                <div className={"flex justify-start items-center space-x-[8px]"}>
                    <LevelACardHeaderText text={"2. Ce que je dois savoir résoudre"} />
                    <LevelAQuestionButton onClick={processModalOpening} />
                </div>
                {/** CONTENT */}
                <div className={"mt-[16px] w-full flex flex-col justify-start items-center"}>
                    <div className={"w-full flex items-stretch space-x-[12px]"}>
                        <LevelAExampleQuestion question={exampleQuestion}
                                               picture={examplePicture}
                                               isTextCentered={isNullOrUndefined(examplePicture)} />
                        <LevelAExampleAnswer answer={exampleAnswer}
                                             isTextCentered={isNullOrUndefined(examplePicture)}
                                             isBrevetDisplay={isBrevetDisplay}/>
                    </div>
                    <LevelAExampleExplanation explanation={exampleExplanation} />
                </div>
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}